import { render, staticRenderFns } from "./SidebarProductSuppliersBlock.vue?vue&type=template&id=0b8cdd1e&scoped=true"
import script from "./SidebarProductSuppliersBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarProductSuppliersBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarProductSuppliersBlock.vue?vue&type=style&index=0&id=0b8cdd1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8cdd1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8cdd1e')) {
      api.createRecord('0b8cdd1e', component.options)
    } else {
      api.reload('0b8cdd1e', component.options)
    }
    module.hot.accept("./SidebarProductSuppliersBlock.vue?vue&type=template&id=0b8cdd1e&scoped=true", function () {
      api.rerender('0b8cdd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarProductSuppliersBlock.vue"
export default component.exports